import React, { useEffect, useState } from 'react';
import api from '../services/api';

export default function ZonePage() {
  const [zone, setZone]         = useState([]);
  const [scoperti, setScoperti] = useState([]);
  const [scelte, setScelte]     = useState({});   // clienteId -> zona
  const [loading, setLoading]   = useState(true);
  const [salvati, setSalvati]   = useState({});   // clienteId -> true

  const carica = async () => {
    setLoading(true);
    try {
      const [rz, rs] = await Promise.all([
        api.get('/zone'),
        api.get('/zone/scoperti'),
      ]);
      const listaZone = (rz.data?.data || []).map(z => ({ nome: z.zona, n: z.n }));
      setZone(listaZone);
      const lista = rs.data?.data || [];
      setScoperti(lista);
      const pre = {};
      lista.forEach(c => { if (c.zonaSuggerita) pre[c.id] = c.zonaSuggerita; });
      setScelte(pre);
    } catch (e) {
      console.error(e);
    } finally { setLoading(false); }
  };

  useEffect(() => { carica(); }, []);

  const salva = async (id) => {
    const z = scelte[id];
    if (!z) { window.alert('Scegli una zona.'); return; }
    try {
      await api.put(`/clienti/${id}/zona`, { zona: z });
      setSalvati(s => ({ ...s, [id]: true }));
    } catch (e) {
      window.alert('Errore: ' + (e?.response?.data?.error || e.message));
    }
  };

  const daFare = scoperti.filter(c => !salvati[c.id]);
  const th = {padding:'8px 10px', background:'#f1f5f9', fontSize:11, textAlign:'left'};

  return (
    <div className="page-content">
      <h2 style={{margin:'0 0 4px', fontSize:18}}>Zone clienti</h2>
      <p style={{margin:'0 0 16px', fontSize:13, color:'#6b7280'}}>
        La zona suggerita viene dedotta dai clienti geolocalizzati piu&apos; vicini.
        Controllala sempre prima di salvare.
      </p>

      {loading ? <div className="loading"><div className="spinner"></div></div> : (
        <>
          <div className="card" style={{padding:12, marginBottom:16}}>
            <div style={{fontSize:13, fontWeight:600, marginBottom:8}}>
              Zone in uso ({zone.length})
            </div>
            <div style={{display:'flex', flexWrap:'wrap', gap:6}}>
              {zone.map(z => (
                <span key={z.nome} style={{fontSize:12, padding:'3px 8px',
                  background:'#f1f5f9', borderRadius:12}}>
                  {z.nome} <strong>{z.n}</strong>
                </span>
              ))}
            </div>
          </div>

          <div style={{fontSize:13, fontWeight:600, marginBottom:8}}>
            Clienti senza zona ({daFare.length})
          </div>

          <div className="card" style={{padding:0}}>
            <div className="table-wrap">
              <table className="q-table">
                <thead><tr>
                  <th style={th}>Cliente</th>
                  <th style={th}>Indirizzo</th>
                  <th style={th}>Zona</th>
                  <th style={th}></th>
                </tr></thead>
                <tbody>
                  {daFare.length === 0 && (
                    <tr><td colSpan={4} style={{textAlign:'center', color:'#9ca3af', padding:32}}>
                      Tutti i clienti hanno una zona
                    </td></tr>
                  )}
                  {daFare.map(c => (
                    <tr key={c.id}>
                      <td style={{fontSize:13}}><strong>{c.nome}</strong></td>
                      <td style={{fontSize:12, color:'#6b7280'}}>
                        {c.indirizzo || '\u2014'}
                      </td>
                      <td>
                        <select className="form-control" style={{fontSize:12, maxWidth:200}}
                          value={scelte[c.id] || ''}
                          onChange={e => setScelte(s => ({...s, [c.id]: e.target.value}))}>
                          <option value="">&mdash; scegli &mdash;</option>
                          {zone.map(z => (
                            <option key={z.nome} value={z.nome}>{z.nome}</option>
                          ))}
                        </select>
                        {c.zonaSuggerita && (
                          <div style={{fontSize:11, color:'#9ca3af', marginTop:2}}>
                            suggerita: {c.zonaSuggerita}
                          </div>
                        )}
                      </td>
                      <td>
                        <button className="btn btn-primary btn-sm"
                          onClick={() => salva(c.id)}>Salva</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div style={{marginTop:32}}>
            <PosizionaClienti />
          </div>
        </>
      )}
    </div>
  );
}

function PosizionaClienti() {
  const [lista, setLista]     = React.useState([]);
  const [sel, setSel]         = React.useState(null);
  const [pronto, setPronto]   = React.useState(!!window.L);
  const [msg, setMsg]         = React.useState('');
  const divRef   = React.useRef(null);
  const mappaRef = React.useRef(null);
  const markerRef= React.useRef(null);
  const puntoRef = React.useRef(null);

  const carica = React.useCallback(() => {
    api.get('/zone/senza-coordinate')
      .then(r => setLista(r.data?.data || []))
      .catch(() => setLista([]));
  }, []);

  React.useEffect(() => { carica(); }, [carica]);

  // Leaflet e' gia' caricato dalla mappa clienti; se manca lo si aspetta
  React.useEffect(() => {
    if (window.L) { setPronto(true); return; }
    const t = setInterval(() => { if (window.L) { setPronto(true); clearInterval(t); } }, 300);
    return () => clearInterval(t);
  }, []);

  React.useEffect(() => {
    if (!pronto || !divRef.current || mappaRef.current) return;
    const L = window.L;
    const m = L.map(divRef.current).setView([41.9028, 12.4964], 11);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      { attribution: '&copy; OpenStreetMap', maxZoom: 19 }).addTo(m);
    m.on('click', (e) => {
      puntoRef.current = e.latlng;
      if (markerRef.current) markerRef.current.setLatLng(e.latlng);
      else markerRef.current = L.marker(e.latlng).addTo(m);
      setMsg(`Punto scelto: ${e.latlng.lat.toFixed(6)}, ${e.latlng.lng.toFixed(6)}`);
    });
    mappaRef.current = m;
    setTimeout(() => m.invalidateSize(), 200);
  }, [pronto]);

  const salva = async () => {
    if (!sel)  { window.alert('Scegli prima un cliente.'); return; }
    if (!puntoRef.current) { window.alert('Clicca sulla mappa per indicare il punto.'); return; }
    try {
      await api.put(`/clienti/${sel}/coordinate`, {
        latitudine:  Number(puntoRef.current.lat.toFixed(7)),
        longitudine: Number(puntoRef.current.lng.toFixed(7)),
      });
      setMsg('Posizione salvata.');
      puntoRef.current = null;
      if (markerRef.current && mappaRef.current) {
        mappaRef.current.removeLayer(markerRef.current);
        markerRef.current = null;
      }
      setSel(null);
      carica();
    } catch (e) {
      window.alert('Errore: ' + (e?.response?.data?.error || e.message));
    }
  };

  const cliente = lista.find(c => String(c.id) === String(sel));

  return (
    <>
      <div style={{fontSize:13, fontWeight:600, marginBottom:8}}>
        Clienti senza posizione ({lista.length})
      </div>
      <p style={{fontSize:12, color:'#6b7280', margin:'0 0 12px'}}>
        Scegli il cliente, clicca il punto esatto sulla mappa e salva.
        La posizione inserita a mano non viene piu&apos; sovrascritta dalla geocodifica.
      </p>

      <div style={{display:'flex', gap:8, marginBottom:8, flexWrap:'wrap',
                   alignItems:'center'}}>
        <select className="form-control" style={{maxWidth:340, fontSize:13}}
          value={sel || ''} onChange={e=>setSel(e.target.value || null)}>
          <option value="">&mdash; scegli un cliente &mdash;</option>
          {lista.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
        <button className="btn btn-primary btn-sm" onClick={salva}>Salva posizione</button>
        {msg && <span style={{fontSize:12, color:'#6b7280'}}>{msg}</span>}
      </div>

      {cliente && (
        <div style={{fontSize:12, color:'#6b7280', marginBottom:8}}>
          {[cliente.indirizzo, cliente.cap, cliente.citta].filter(Boolean).join(' \u00b7 ')}
        </div>
      )}

      <div ref={divRef} style={{height:420, borderRadius:8, border:'1px solid #e5e7eb'}} />
    </>
  );
}
